const list = ['D774','KR26','MY23','NI86','NI87','OI64','OI65','OJ22','OJ23','OL64','OL65','OL66','Y867','Y819','KB55','KB56','KD85','KW23','LP51','ME02','NC34','NZ02','OL63','OL64','OL66','ON02','Y819'];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}